import { HubConnection } from '@microsoft/signalr';
import { logger } from '../../../lib/helpers';
import {
  HomeworkHubMessage,
  HomeworkKvEntryUpdateModel,
  HomeworkSimplePeerSignal
} from '../homework-models';

export type HomeworkTask = (connection: HubConnection) => Promise<HomeworkHubMessage>;

function echo(message: string): HomeworkTask {
  return (connection) => {
    logger.log('HomeworkHub.echo');
    return connection.invoke<HomeworkHubMessage>(
      'echo', message);
  };
}

function joinAsTeacher(homeworkId: number): HomeworkTask {
  return (connection) => {
    logger.log('HomeworkHub.joinAsTeacher');
    return connection.invoke<HomeworkHubMessage>('joinAsTeacher', homeworkId);
  };
}

function joinAsStudent(homeworkId: number): HomeworkTask {
  return (connection) => {
    logger.log('HomeworkHub.joinAsStudent');
    return connection.invoke<HomeworkHubMessage>('joinAsStudent', homeworkId);
  };
}

function setCurrentPushableBlock(pushableBlockSnapshotId: number): HomeworkTask {
  return (connection) => {
    logger.log('HomeworkHub.setCurrentPushableBlock');
    return connection.invoke<HomeworkHubMessage>(
      'setCurrentPushableBlock', pushableBlockSnapshotId);
  };
}

function getKeyValuesPart(homeworkId: number, changeStamps: readonly number[]): HomeworkTask {
  return (connection) => {
    logger.log('HomeworkHub.getKeyValuesPart');
    return connection.invoke<HomeworkHubMessage>(
      'getKeyValuesPart', homeworkId, changeStamps);
  };
}

function updateKeyValues(homeworkId: number, keyValues: readonly HomeworkKvEntryUpdateModel[]): HomeworkTask {
  return (connection) => {
    logger.log('HomeworkHub.updateKeyValues', keyValues);
    return connection.invoke<HomeworkHubMessage>(
      'updateKeyValues', homeworkId, keyValues);
  };
}

function simplePeerSignal(signal: HomeworkSimplePeerSignal): HomeworkTask {
  return (connection) => {
    logger.log('HomeworkHub.simplePeerSignal', signal);
    return connection.invoke<HomeworkHubMessage>(
      'simplePeerSignal', signal);
  };
}

class HomeworkTasksClass {
  readonly echo = echo;
  readonly joinAsStudent = joinAsStudent;
  readonly joinAsTeacher = joinAsTeacher;
  readonly getKeyValuesPart = getKeyValuesPart;
  readonly updateKeyValues = updateKeyValues;
  readonly simplePeerSignal = simplePeerSignal;
}

export const HomeworkTasks = new HomeworkTasksClass();
